 import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpService } from './http.service';
import { protectedResources } from '../auth-config';
import { cpoSearch } from '../pages/models/cpo-search.models';
import { TransactionSearchDto } from '../pages/models/transaction.models';

@Injectable({ providedIn: 'root' })
export class CommonService {


  constructor(
    private apiServiceRequest: HttpService,
    private _http: HttpClient) {
  }

  /**
   * generic get service
   */
  async GetMenuSide() {
    const baseurl = '/api/Menu/GetUserMenu';
    return await this.apiServiceRequest.getAllLocal(baseurl).toPromise();
  }


  async GetAllCpo(item: cpoSearch) {
    const baseurl = '/api/RequestChargePointOperator/GetAllCpo';
    return await this.apiServiceRequest.SendLocal(baseurl, item).toPromise();
  }
  async GetRequestDocuments() {
    return await this.apiServiceRequest.getAllLocal("./api/RequestCPO/GetRequestDocuments").toPromise();
  }

  async GetCpoById(requestId: any) {
    const baseurl = '/api/RequestChargePointOperator/GetCpoById?requestId=' + requestId;
    return await this.apiServiceRequest.getAllLocal(baseurl).toPromise();
  }
  async SetWorkFlowAuthenticateToken() {
    return await this.apiServiceRequest.getAllLocal("/api/WorkFlow/Authenticate").toPromise();
  }

  async SetCPOWorkFlowAuthenticateToken() {
    return await this.apiServiceRequest.getAllLocal("/api/WorkFlow/AuthenticateCPO").toPromise();
  }
  
  async SearchTransactions(item: TransactionSearchDto) {
    const baseurl = '/api/Transaction/SearchTransaction';
    return await this.apiServiceRequest.SendLocal(baseurl, item).toPromise();
  }

  async GetSearchCpo(item: cpoSearch) {
    const baseurl = '/api/RequestChargePointOperator/SearchCpo';
    return await this.apiServiceRequest.SendLocal(baseurl, item).toPromise();
  }
  async UpdatePassword(email: string) {
    return await this.apiServiceRequest.getAllLocal("/api/AccountProfile/UpdatePassword?email="+email).toPromise();
  }

  url = protectedResources.apiMenueList.endpoint;

  getMenuSide() {
    return this._http.get<any[]>(this.url);
  }

  getLoggedInUser() {
    return sessionStorage.getItem("token");
  }

  hasLoggedUser() { }

}




